var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.0001,
    cy: 19.328,
    rx: 18.8133,
    ry: 18.8133,
    fill: "#7CB6E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6366 26.3877H23.6982V21.2426C23.6982 19.8312 23.076 19.0437 21.9601 19.0437C20.7458 19.0437 20.0252 19.8643 20.0252 21.2426V26.3877H17.0868V16.8312H20.0252V17.9058C20.0252 17.9058 20.9471 16.287 23.0246 16.287C25.1028 16.287 26.6366 17.5561 26.6366 20.1819V26.3877ZM13.7385 15.3028C12.7475 15.3028 11.9446 14.4927 11.9446 13.4937C11.9446 12.4954 12.7475 11.6853 13.7385 11.6853C14.7287 11.6853 15.5316 12.4954 15.5316 13.4937C15.5324 14.4927 14.7287 15.3028 13.7385 15.3028ZM11.9446 26.3877H15.6176V16.8312H11.9446V26.3877Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.178642327bb654ab34a07ca18df8439b.svg";
export { ForwardRef as ReactComponent };